exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".privacy-popup[data-v-9c64e026] {\n  line-height: 22px;\n  color: #21364c;\n}\n.privacy-popup h2[data-v-9c64e026] {\n  border-bottom: none;\n}\n.privacy-popup p[data-v-9c64e026] {\n  margin-bottom: 18px;\n  line-height: 22px;\n  color: #21364c;\n}\n.privacy-popup a[data-v-9c64e026] {\n  color: #00f;\n  text-decoration: underline;\n}\n.privacy-popup strong[data-v-9c64e026] {\n  font-weight: 700;\n}", ""]);

// exports
